import React from 'react';
import LoadingImage from '../../../Global/LoadingImage/LoadingImage';

import {
	ToastCaption,
	ToastHeader,
	ToastImg,
	ToastInnerContainer,
	ToastTextContainer,
	ToastTitle,
} from './toastStyles';
import { useAppSelector } from '../../../../state/hooks';
import { RootState } from '../../../../state/store';
import { shallowEqual } from 'react-redux';

const ToastInner: React.FC = () => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	return (
		<ToastInnerContainer>
			{network_status && (
				<ToastImg>
					<LoadingImage src="https://picsum.photos/200/200" />
				</ToastImg>
			)}
			<ToastTextContainer className={network_status ? '' : 'offline'}>
				<ToastHeader>Coming up next</ToastHeader>
				<ToastTitle>Point title</ToastTitle>
				<ToastCaption>
					A Toast is a subtle notification commonly used in modern
					applications. It can be used to provide feedback about an
					operation or to display a system message.
				</ToastCaption>
			</ToastTextContainer>
		</ToastInnerContainer>
	);
};

export default ToastInner;
